import { Alert, Stack, Text } from '@mantine/core'
import type { SocTeam } from '@/api/soc'

type Props = {
  time: Pick<SocTeam, 'tenant_name' | 'tenant_environment' | 'tenant_account_id' | 'organizacoes_do_tenant'>
}

/**
 * O tenant e a identidade do time de SOC: decide quais alertas ele recebe e
 * quem pode ser integrante, e NAO muda depois de criado (spec
 * 2026-09-24-soc-tenant-explicito, §3). O nome do time e texto livre — esta
 * linha e o que diz de verdade onde o time atua.
 */
export function TenantDoTime({ time }: Props) {
  const resto = [time.tenant_environment?.toUpperCase()]
  if (time.tenant_account_id) resto.push(`conta ${time.tenant_account_id}`)
  return (
    <Stack gap="xs">
      <Text size="sm">
        Atua no tenant{' '}
        <Text span fw={600} inherit>
          {time.tenant_name}
        </Text>
        {` · ${resto.join(' · ')}`}
      </Text>
      {time.organizacoes_do_tenant.length === 0 && (
        <Alert color="yellow">
          Este tenant não pertence a nenhuma organização. Só a plataforma administra
          este time, e ninguém entra nele pela organização. O time continua alarmando.
        </Alert>
      )}
    </Stack>
  )
}
